import { render, staticRenderFns } from "./ScreenTabStatusFooter.vue?vue&type=template&id=35147142&scoped=true&"
import script from "./ScreenTabStatusFooter.vue?vue&type=script&lang=js&"
export * from "./ScreenTabStatusFooter.vue?vue&type=script&lang=js&"
import style0 from "./ScreenTabStatusFooter.vue?vue&type=style&index=0&id=35147142&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35147142",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
